import { useContext } from 'react';
import { AlertContext } from '../contexts/AlertContext';

export default function Alert() {
  const [alert, , hideAlert] = useContext(AlertContext);

  return (
    <>
      {alert !== null ? (
        <div
          style={{ position: 'fixed', inset: '1rem 0 auto', zIndex: 300000 }}
        >
          <div className="container">
            <div className="alert">
              <div className={`alert alert-${alert.status}`} role="alert">
                {alert.text}
                <button
                  type="button"
                  className="close"
                  aria-label="Close"
                  onClick={hideAlert}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
